import { Pressable, View } from 'react-native'

import { Icon, symbolName } from '../../../components/ui/Icon'

interface VisualMediaPlayerOverlayProps {
  isFullscreen: boolean
  isMuted: boolean
  isPlaying: boolean
  onToggleFullscreen: () => void
  onToggleMute: () => void
  showMuteControl?: boolean
}

function getFullscreenIconName(isFullscreen: boolean) {
  return isFullscreen
    ? symbolName('arrow.down.right.and.arrow.up.left', 'fullscreen_exit')
    : symbolName('arrow.up.left.and.arrow.down.right', 'fullscreen')
}

function getMuteIconName(isMuted: boolean) {
  return isMuted
    ? symbolName('speaker.slash', 'volume_off')
    : symbolName('speaker.wave.3', 'volume_up')
}

// oxlint-disable-next-line react-doctor/no-many-boolean-props -- overlay flags stay simple for this player UI
export function VisualMediaPlayerOverlay({
  isFullscreen,
  isMuted,
  isPlaying,
  onToggleFullscreen,
  onToggleMute,
  showMuteControl = true,
}: VisualMediaPlayerOverlayProps) {
  return (
    <>
      <View
        className="absolute top-4 left-4"
        style={{ pointerEvents: 'box-none', zIndex: 10 }}
      >
        <Pressable
          className="bg-black/50 p-2 rounded-lg"
          onPress={onToggleFullscreen}
        >
          <Icon
            name={getFullscreenIconName(isFullscreen)}
            size={20}
            color="white"
          />
        </Pressable>
      </View>

      {showMuteControl && (
        <View
          className="absolute top-4 right-4"
          style={{ pointerEvents: 'box-none', zIndex: 10 }}
        >
          <Pressable
            className="bg-black/50 p-2 rounded-lg"
            onPress={onToggleMute}
          >
            <Icon name={getMuteIconName(isMuted)} size={20} color="white" />
          </Pressable>
        </View>
      )}

      {!isPlaying && (
        <View
          className="absolute inset-0 items-center justify-center"
          style={{ pointerEvents: 'none', zIndex: 10 }}
        >
          <View className="bg-black/40 w-16 h-16 rounded-full items-center justify-center">
            <Icon
              name={symbolName('play.fill', 'play_arrow')}
              size={32}
              color="white"
              className="ml-1"
            />
          </View>
        </View>
      )}
    </>
  )
}
